module.exports = __webpack_public_path__ + "img/clock-check.196b1989.svg";